import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ee1f994"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee1f994')) {
      api.createRecord('7ee1f994', component.options)
    } else {
      api.reload('7ee1f994', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ee1f994", function () {
      api.rerender('7ee1f994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipWeekClassCount/index.vue"
export default component.exports